import { ActionIcon, Flex, Tooltip } from '@mantine/core';
import { TbChevronDown, TbMailForward, TbSettings, TbTrash } from 'react-icons/tb';

const ReviewerActions = ({
  approverId,
  opened,
  invitationSent,
  isLocked,
  resending,
  onToggle,
  onResend,
  onDelete
}) => (
  <Flex gap="10px" align="center" wrap="nowrap" style={{ marginLeft: 'auto' }}>
    {!isLocked && invitationSent && (
      <Tooltip label="Re-send the email notification" withArrow withinPortal>
        <ActionIcon
          id={`resend-invite-btn-${approverId}`}
          variant="subtle"
          color="gray"
          size="md"
          aria-label="Re-send the email notification"
          loading={resending}
          onClick={onResend}
        >
          <TbMailForward fontSize="17px" />
        </ActionIcon>
      </Tooltip>
    )}
    <ActionIcon
      variant={opened ? 'light' : 'subtle'}
      color={opened ? 'blue' : 'gray'}
      size="md"
      w={40}
      aria-label="Edit access"
      onClick={onToggle}
    >
      <Flex align="center" gap="1px">
        <TbSettings fontSize="17px" />
        <TbChevronDown fontSize="10px" style={{ transform: opened ? 'rotate(180deg)' : 'none' }} />
      </Flex>
    </ActionIcon>
    {!isLocked && (
      <ActionIcon variant="white" size="sm" aria-label="Remove reviewer">
        <TbTrash onClick={onDelete} fontSize="16px" color="#CED4DA" />
      </ActionIcon>
    )}
  </Flex>
);

export default ReviewerActions;
